// extracted by mini-css-extract-plugin
export default {"wrapper-background":"Bomba_wrapper-background__dtcK8","items":"Bomba_items__hfktO","hearts":"Bomba_hearts__O-OGh"};